class CartFilterController {}

const cartFilterComponentDefinition = {
    bindings: {
        searchFilter: '=',
        itemCount: '=',
    },
    controller: CartFilterController,
    template: require('./cart-filter.component.html').trim(),
};

module.exports = {
    CartFilterController,
    cartFilterComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-filter.component.js